import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  // ✅ When logo is clicked: navigate to /new-quotation and refresh
  const handleLogoClick = () => {
    if (location.pathname === '/new-quotation') {
      // If already there, just refresh
      window.location.reload();
    } else {
      // Navigate and refresh
      navigate('/new-quotation');
      setTimeout(() => window.location.reload(), 100);
    }
  };

  return (
    <header className="app-header">
      <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img 
          src="/images/BP_Logo.png"   // ✅ place image in public/images/
          alt="Bharat Packs Logo" 
          className="logo-image"
        />
      </div>

      <nav className="nav-bar">
        <Link 
          to="/new-quotation" 
          className={`nav-link ${location.pathname === '/new-quotation' ? 'active' : ''}`}
        >
          New Quotation
        </Link>

        <Link 
          to="/list-quotation" 
          className={`nav-link ${location.pathname === '/list-quotation' ? 'active' : ''}`}
        >
          Quotations
        </Link>

        <button onClick={handleLogout} className="nav-button">
          Logout
        </button>
      </nav>
    </header>
  );
};

export default Header;
